export enum SlackChannels {
  DueToReorder = 'C08FCAM9V5G',
  GeneralFeedback = 'C086FFTMZJ8',
  Intelligence = 'C08FDQGSTD5'
}

export enum SlackChannelsDev {
  DueToReorder = 'C08FCAM9V5G',
  GeneralFeedback = 'C086FFTMZJ8',
  Intelligence = 'C09F8U4N52N'
}

export enum SlackMessageTypes {
  ProductMatch = 'Product Match',
  AutoRFQ = 'Auto RFQ',
  SalesEnablement = 'Sales Enablement',
  Catalog = 'Catalog',
  API = 'API',
  IntelligenceErrors = 'Intelligence Errors',
  ReorderIntelligence = 'Reorder Intelligence',
  DueToReorder = 'Due To Reorder',
  RetentionIntelligence = 'Retention Intelligence',
  WhitespaceIntelligence = 'Whitespace Intelligence'
}
